import { SelectedFilters as BaseComponent } from "lemans-brandsites-common/components/SelectedFilters/SelectedFilters.component";
import * as React from 'react';
import './SelectedFilters.styles.less';
import { ISelectedFiltersProps } from "./SelectedFilters.types";

export const SelectedFilters = (props:ISelectedFiltersProps) => <BaseComponent {...props} />;
